// An invite link (PRD F1): /i/<code>. Signing in first comes back here; opening it asks to be friends
// with whoever shared it (or accepts, if they already asked). Set as a plate: two friends looking at
// the same light, in a church window, and one sentence that says what happened.
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { Art } from "../../components/Art";
import { LinkButton } from "../../components/Button";
import ui from "../../components/ui.module.css";
import { keys, useSource } from "../../data/queries";
import { useTitle } from "../../lib/useTitle";
import s from "./invite.module.css";

export const Route = createFileRoute("/_app/i/$code")({ component: Invite });

function Invite() {
  useTitle("Invite");
  const { code } = Route.useParams();
  const source = useSource();
  const qc = useQueryClient();
  const ask = useMutation({
    mutationFn: () => source.requestFriendByInvite(code),
    meta: { inline: true },
    onSuccess: () => void qc.invalidateQueries({ queryKey: keys.friends }),
  });
  const { mutate } = ask;
  const asked = useRef(false);
  useEffect(() => {
    if (asked.current) return;
    asked.current = true;
    mutate();
  }, [mutate]);

  return (
    <div className={ui.page}>
      <section className={s.plate} aria-labelledby="invite-title" aria-busy={ask.isPending || undefined}>
        <Art name="friedrich" shape="arch" focus="50% 30%" ratio="4 / 5" decorative arrive className={s.art} />
        <h1 id="invite-title" className={s.title}>
          {ask.isSuccess ? "Your request is on its way." : ask.isError ? "This invite didn’t open." : "Opening the invite…"}
        </h1>
        <p className={s.body} role={ask.isError ? "alert" : undefined}>
          {ask.isSuccess
            ? "You’ll be friends once they accept, or straight away if they’d already asked."
            : ask.isError
              ? ask.error.message
              : "One moment while we find who shared it."}
        </p>
        <div className={s.actions}>
          <LinkButton to="/friends" variant={ask.isSuccess ? "primary" : "secondary"}>
            Go to Friends
          </LinkButton>
          {ask.isSuccess && (
            <LinkButton to="/home" variant="ghost">
              Home
            </LinkButton>
          )}
        </div>
      </section>
    </div>
  );
}
